import * as React from 'react'
import type { Color } from '../../../theme/colors'
import colors from '../../../theme/colors'

type Props = React.SVGProps<SVGSVGElement> & {
  width?: number
  height?: number
  color?: Color
}

const HamburgerSvg = ({ width, height, color, ...props }: Props) => (
  <svg {...props} width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 6H20" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4 12H20" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4 18H20" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

HamburgerSvg.defaultProps = {
  width: 24,
  height: 24,
  color: colors.Primary.GreyText,
}

export default HamburgerSvg
